<!-- HM tour -->
<template>
  <div v-if="progressDownloaded && (!tourFlag || !progressFlags[tourFlag])" class="hmtour">
    <b-popover v-for="(step, index) in tour" :key="id + index" :target="step.target" :placement="step.placement ? step.placement : 'bottom'" :show="currentStep == index" triggers>
      <div v-if="step.title" slot="title">
        <span :class="step.icon ? step.icon : 'icon-direction'"></span>
        <span class="pl-3">{{step.title}}</span>
      </div>
      <div v-html="step.content"></div>
      <hr class="mb-1">
      <div>
        <b-row class="pb-2">
          <b-col>
            <b-form-checkbox plain inline v-model="save">Don't show this again</b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-button v-if="index < tour.length-1" type="button" variant="light" size="sm" @click="onExit">Skip</b-button>
          </b-col>
          <b-col cols="8" class="text-right">
            <b-button v-if="index > 0" class="mr-2" type="button" variant="light" size="sm" @click="currentStep -= 1">
              <i class="fa fa-caret-left pr-2"></i>
              Prev
            </b-button>
            <b-button v-if="index < tour.length -1" type="button" variant="light" size="sm" @click="currentStep += 1">
              Next
              <i class="fa fa-caret-right pl-2"></i>
            </b-button>
            <b-button v-if="index == tour.length-1" type="button" variant="light" size="sm" @click="onExit">Exit</b-button>
          </b-col>
        </b-row>
      </div>
    </b-popover>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'HMTour',
  props: {
    id: {
      type: String,
      default: function () {
        return 'tour-id-' + this._uid;
      }
    },
    tour: {
      type: Array
    },
    tourFlag: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      currentStep: 0,
      save: false
    }
  },
  computed: {
    ...mapState('progress', { progressFlags: 'flags' }),
    ...mapState('progress', { progressDownloaded: 'downloaded' })
  },
  methods: {
    ...mapActions({
      setProgress: 'progress/setFlagDone'
    }),
    onExit() {
      console.log('Tour: tour complete =>', this.tourFlag, this.save);

      this.currentStep = -1; // set to invalid step
      if (this.tourFlag && this.save) {
        this.setProgress(this.tourFlag);
      }
    }
  }
}
</script>

<style>
.popover {
  width: 400px;
  max-width: none; /* Required for popovers wider than 276px (Bootstrap's max-width for popovers) */
}
</style>